import { FormDialogTemplate } from "../../../../../../../shared/form-dialog/form-dialog.template";
import { FormGroup, FormControl } from "@angular/forms";
import { BehaviorSubject } from "rxjs";
import { PartDetailService } from "../../part-detail.service";
import { PartListService } from "../../../part-list.service";
import { DistributionCategoryService, DistributionMethodService } from "../../../../../phf.service";
import { PartLoadingTabComponent } from "../part-loading-tab.component";
import { Injector } from "@angular/core";

export class DistributionMethodDialogTemplate extends FormDialogTemplate {

    dialogTitle: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);
    editformworker: any;
    editForm: FormGroup;
    categories: any;
    private readonly messageService: PartDetailService;
    private readonly partListService: PartListService;
    private readonly distributionCategoryService: DistributionCategoryService;
    private readonly distributionMethodService: DistributionMethodService;
    constructor(
        private readonly injector: Injector,
        private readonly partLoadingTabComponent: PartLoadingTabComponent
    ) {
        super();
        this.messageService = injector.get(PartDetailService);
        this.partListService = injector.get(PartListService);
        this.distributionCategoryService = injector.get(DistributionCategoryService);
        this.distributionMethodService = injector.get(DistributionMethodService);


        this.distributionCategoryService.read()
            .then(response => {
                if (response) {
                    this.categories = response;
                }
                this.createEditForm();
                this.createControls();
            });
        this.editformworker = this.editForm;

        this.initilize("- " + partLoadingTabComponent.part.Code, this.editForm, this.formDialogTabs);
    }

    save = ({ dataItem }): void => {
        this.partListService.closeDialog();
        this.partLoadingTabComponent.partDetailComponent.isVisDialog = true;
        this.partLoadingTabComponent.isOpen = true;
        this.partLoadingTabComponent.setDistributionValue(dataItem.DistributionMethod);
        this.partLoadingTabComponent.isOpen = true;
        this.partLoadingTabComponent.displayFunction();
    }
    cancel = x => {
        this.partLoadingTabComponent.partDetailComponent.isVisDialog = true;
        this.partLoadingTabComponent.isOpen = true;
        this.partLoadingTabComponent.displayFunction();
        this.partListService.closeDialog();
    }
    clicked = (dataItem: any) => {
        const textAreaValue = this.editformworker.get("DistributionMethod").value;
        if (dataItem === undefined) {
            //do nothing
        } else if (!(textAreaValue == null)) {
            this.editformworker.get("DistributionMethod").setValue(textAreaValue + dataItem);
        } else {
            this.editformworker.get("DistributionMethod").setValue(dataItem);
        }
    }

    createEditForm() {
        this.editForm.addControl("DistributionMethod", new FormControl(this.value.DistributionMethod));
        this.categories.forEach(category => {
            this.editForm.addControl(category.Name.replace(/ /g, ''), new FormControl(''));
        });
    }

    createControls() {
        this.categories.forEach(category => {
            const categoryControl = {
                type: "combobox",
                name: category.Name.replace(/ /g, ''),
                title: category.Name,
                textField: "Description",
                valueField: "Description",
                service: this.distributionMethodService.read("/category/" + category.Id),
                onChange: this.clicked,
                height: 100,
                stretch: true,
            }
            this.formControls.push(categoryControl);
        });
        this.formControls.push({
            type: "textarea",
            rows: 4,
            name: "DistributionMethod",
            title: "Distribution Note",
            stretch: true,
        })
    }

    formControls = []

    formDialogTabs = [
        {
            title: "Distribution Method",
            selected: true,
            formControls: this.formControls
        },
    ]

}
